"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventDispatcher_1 = __importDefault(require("../EventDispatcher"));
class EventManager extends EventDispatcher_1.default {
    constructor() {
        super();
        this.dom = null;
        this.resizeEvent = { type: 'resize' };
        this.orientationChangeEvent = { type: 'orientationchange' };
        this.mouseMoveEvent = { type: 'mousemove' };
        this.touchStartEvent = { type: 'touchstart' };
        this.touchEndEvent = { type: 'touchend' };
        this.touchMoveEvent = { type: 'touchmove' };
        this.clickEvent = { type: 'click' };
        this.mousePositionEvent = { type: 'mouse-position' };
        this.cameraPositionTargetEvent = { type: 'camera-position-target' };
    }
    init(dom) {
        this.dom = dom;
        this.dom.addEventListener('mousemove', this.onMouseMove.bind(this));
        this.dom.addEventListener('click', this.onClick.bind(this));
        this.dom.addEventListener('touchstart', this.onTouchStart.bind(this), false);
        this.dom.addEventListener('touchend', this.onTouchEnd.bind(this), false);
        this.dom.addEventListener('touchmove', this.onTouchMove.bind(this), false);
        window.addEventListener('resize', this.resize.bind(this));
        window.addEventListener('orientationchange', this.onOrientationChange.bind(this));
    }
    resize() {
        this.dispatchEvent(this.resizeEvent);
    }
    onOrientationChange() {
        this.dispatchEvent(this.orientationChangeEvent);
    }
    onMouseMove(e) {
        e.preventDefault();
        this.mouseMoveEvent.originEvent = e;
        this.dispatchEvent(this.mouseMoveEvent);
    }
    onClick(e) {
        e.preventDefault();
        this.clickEvent.originEvent = e;
        this.dispatchEvent(this.clickEvent);
    }
    onTouchStart(e) {
        e.preventDefault();
        if (e.touches.length === 1) {
            this.touchStartEvent.originEvent = e;
            this.dispatchEvent(this.touchStartEvent);
        }
    }
    onTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.touches.length === 1) {
            this.touchMoveEvent.originEvent = e;
            this.dispatchEvent(this.touchMoveEvent);
        }
    }
    onTouchEnd(e) {
        e.preventDefault();
        if (e.touches.length === 0) {
            this.touchEndEvent.originEvent = e;
            this.dispatchEvent(this.touchEndEvent);
        }
    }
}
exports.default = EventManager;
